import sanitizeHtml from 'sanitize-html'

import { findBlocks } from '@/modules/templates/templateEditor/editorHelper'
import {
  RichTextCaptureBlock,
  TemplateData,
} from '@/modules/templates/types/blueprint'

export const convertRichBlocksToText = (richBlocks: RichTextCaptureBlock[]) => {
  if (!richBlocks.length) return ''

  // create a div element to hold the rich blocks content
  const magicWrapperDiv = document.createElement('div')

  // loop through each rich block and append it to the div
  richBlocks.forEach((block) => {
    const element = document.createElement('div')
    element.innerHTML = sanitizeHtml(block.value) // sanitize html to prevent xss
    magicWrapperDiv.appendChild(element)
  })

  // Get the HTML content of the div
  let textContent = magicWrapperDiv.innerHTML

  // Convert list items to dashes with proper spacing
  textContent = textContent.replace(/<li[^>]*>/gi, '- ')
  textContent = textContent.replace(/<\/li>/gi, '\n')

  // Replace other block elements with newlines
  textContent = textContent.replace(/<\/p>/gi, '\n')
  textContent = textContent.replace(/<\/div>/gi, '\n')
  textContent = textContent.replace(/<br\s*\/?>/gi, '\n')

  // Remove all other HTML tags
  textContent = textContent.replace(/<[^>]*>/g, '')

  // Clean up whitespace
  textContent = textContent.replace(/\n\s*\n/g, '\n') // Remove multiple blank lines
  textContent = textContent.replace(/^\s+|\s+$/g, '') // Trim start/end whitespace
  textContent = textContent.replace(/[ \t]+/g, ' ') // Convert multiple spaces to single space

  return textContent
}

export const convertTemplateRichBlocksToText = (templateData: TemplateData) => {
  if (!templateData) return ''

  const richBlocks = findBlocks(
    templateData,
    (b) => b.type === 'richText'
  ) as RichTextCaptureBlock[]

  return convertRichBlocksToText(richBlocks)
}
